exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 768px) and (max-width: 1095px){img[data-v-0c6a889a]{width:100px}}\n", ""]);

// exports
